import { AxiosPromise } from 'axios';
import { InboundPayload, InboundRoute, SortOrderPayload, SortOrderItem } from '@dev/ee-api/ee-api-models';
import { request } from './request';

export const loadInboundRoutes = (): Promise<InboundRoute[]> => {
    const { Inbound } = request();
    return Inbound.inboundrouteGet().then((resp): InboundRoute[] => resp.data);
};
export const addNewInboundRoute = (inbound: InboundPayload): Promise<InboundRoute> => {
    const { Inbound } = request();
    return Inbound.inboundroutePost(inbound).then((resp): InboundRoute => resp.data);
};
export const updateInboundOrder = (newOrder: SortOrderItem[]): Promise<InboundRoute[]> => {
    const { Inbound } = request();
    const data: SortOrderPayload = {
        Items: newOrder,
    };
    return Inbound.inboundrouteOrderPut(data).then((resp): InboundRoute[] => resp.data);
};
export const deleteInbound = (id: string): AxiosPromise<void> => {
    const { Inbound } = request();
    return Inbound.inboundrouteByIdDelete(id);
};
export const updateInbound = (id: string, inbound: InboundPayload): Promise<InboundRoute> => {
    const { Inbound } = request();
    return Inbound.inboundrouteByIdPut(id, inbound).then((resp): InboundRoute => resp.data);
};
